import React from "react";
import {
  Box,
  Text,
  Button,
  HStack,
  VStack,
  IconButton,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

const ActivityCompletionNotification = ({
  activityName,
  activityType,
  hasLink,
  isVisible,
  onMoveNow,
  onDismiss,
}) => {
  if (!isVisible) return null;

  const isLinkShare = activityType === "share" && hasLink;

  // Different messages for different activity types
  const getMessage = () => {
    if (activityType === "share") {
      return isLinkShare
        ? "🔗 Link sent! Moving to bottom in 30 seconds."
        : "🚀 Announcement sent! Moving to bottom in 30 seconds.";
    }
    return "🚀 Activity completed! Moving to bottom in 30 seconds.";
  };

  const bgColor = isLinkShare ? "#D5F5E3" : "#DBDAF5";
  const buttonBg = isLinkShare ? "#32D583" : "#4C47CC";
  const buttonHoverBg = isLinkShare ? "#28B870" : "#433EC7";

  return (
    <Box bg={bgColor} borderRadius="4px" p={3} w="100%" position="relative">
      <VStack spacing={1.5} align="stretch">
        {/* Top row with text and close button */}
        <HStack justify="space-between" align="flex-start" spacing={1.5}>
          <VStack align="flex-start" spacing={0.5} flex={1}>
            <Text
              fontSize="12px"
              lineHeight="1.5em"
              letterSpacing="-1%"
              color="#14002E"
              fontWeight="400"
            >
              {getMessage()}
            </Text>
          </VStack>

          <IconButton
            aria-label="Close notification"
            icon={<CloseIcon />}
            size="xs"
            variant="ghost"
            color="#0C001C"
            minW="20px"
            h="20px"
            onClick={onDismiss}
            _hover={{ bg: "rgba(12, 0, 28, 0.1)" }}
          />
        </HStack>

        {/* Action buttons */}
        <HStack spacing={1.5} flexWrap="wrap">
          <Button
            size="xs"
            bg={buttonBg}
            color="#FFFFFF"
            border="1px solid #D0CCD5"
            borderRadius="4px"
            px={2}
            py={1.5}
            fontSize="11px"
            lineHeight="1.45em"
            letterSpacing="-1%"
            fontWeight="400"
            _hover={{ bg: buttonHoverBg }}
            onClick={onMoveNow}
          >
            Move Now
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default ActivityCompletionNotification;
